import { useState, useCallback, useEffect } from 'react';

export default ({ open, onEnter, listSize, options, initialFocus = null }) => {
  const [currentFocus, setCurrentFocus] = useState(initialFocus);

  const handleKeyDown = useCallback(
    (event) => {
      switch (event.key) {
      case 'ArrowDown':
        event.preventDefault();
        const focusDownIndex = currentFocus === null || currentFocus === -1 ? 0 : currentFocus === listSize - 1 ? 0 : currentFocus + 1;
        if (options?.[focusDownIndex]?.isGroupHeader) {
          setCurrentFocus(focusDownIndex + 1);
        } else {
          setCurrentFocus(focusDownIndex);
        }
        break;

      case 'ArrowUp':
        event.preventDefault();
        const focuUpIndex = currentFocus === null || currentFocus === -1 ? listSize - 1 : currentFocus === 0 ? listSize - 1 : currentFocus - 1;
        if (options?.[focuUpIndex]?.isGroupHeader) {
          const checkLast = focuUpIndex - 1 === -1 ? listSize - 1 : focuUpIndex - 1;
          setCurrentFocus(checkLast);
        } else {
          setCurrentFocus(focuUpIndex);
        }
        break;

      case 'Enter':
        if (currentFocus >= 0) {
          event.preventDefault();
          onEnter(currentFocus);
        }
        break;

      default:
        break;
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [listSize, currentFocus, setCurrentFocus],
  );

  useEffect(() => {
    open && document.addEventListener('keydown', handleKeyDown, false);

    return () => {
      document.removeEventListener('keydown', handleKeyDown, false);
    };
  }, [handleKeyDown, open]);

  return [currentFocus, setCurrentFocus];
};
